import _typeof from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/typeof";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { emailMeetingMinutes, getEmailTemplatePreview } from "src/models/Email";
import errorDialog from "src/functions/function-show-error-message";
import getErrorPayload from "src/functions/get-error-payload"; // Init state

var initState = function initState() {
  return {
    someVar: "",
    emailTemplatePreview: "",
    emailTemplateLoading: false
  };
}; // State object


var state = initState(); // Mutations

var mutations = {
  setEmailTemplatePreview: function setEmailTemplatePreview(state, preview) {
    state.emailTemplatePreview = preview;
  },
  setEmailTemplateLoading: function setEmailTemplateLoading(state, loading) {
    state.emailTemplateLoading = loading;
  },
  RESET: function RESET(state) {
    var newState = initState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
}; // Actions

var actions = {
  sendMeetingEmails: function sendMeetingEmails(_ref, request) {
    var commit = _ref.commit;
    var group = this.getters["Group/group"];
    var meeting = this.getters["Meeting/meeting"];
    return new Promise(function (resolve) {
      emailMeetingMinutes(group.id, meeting.id, request).then(function () {
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  },
  fetchEmailTemplatePreview: function fetchEmailTemplatePreview(_ref2, emailType) {
    var commit = _ref2.commit;
    commit("setEmailTemplateLoading", true);
    var group = this.getters["Group/group"];
    var meeting = this.getters["Meeting/meeting"];
    return new Promise(function (resolve, reject) {
      getEmailTemplatePreview(group.id, meeting.id, emailType).then(function (response) {
        // Handle response - extract HTML string from object
        // Backend returns: { subject: "...", body: "..." }
        var templateHtml = response.data;

        if (_typeof(response.data) === 'object' && response.data !== null) {
          // Backend returns object with body field containing the HTML
          templateHtml = response.data.body || response.data.html || response.data.template || response.data.content || JSON.stringify(response.data);
        }

        commit("setEmailTemplatePreview", templateHtml);
        commit("setEmailTemplateLoading", false);
        resolve(templateHtml);
      }).catch(function (e) {
        commit("setEmailTemplateLoading", false);
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        reject(e);
      });
    });
  }
}; // Getter functions

var getters = {
  emailTemplatePreview: function emailTemplatePreview(state) {
    // Ensure we always return a string
    var preview = state.emailTemplatePreview;

    if (typeof preview === 'string') {
      return preview;
    }

    if (_typeof(preview) === 'object' && preview !== null) {
      // Backend returns object with body field containing the HTML
      return preview.body || preview.html || preview.template || preview.content || JSON.stringify(preview);
    }

    return '';
  },
  emailTemplateLoading: function emailTemplateLoading(state) {
    return state.emailTemplateLoading;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};